// extracted by mini-css-extract-plugin
export default {"root":"eebsFrslcgt4hez_ovpH","dishTitle":"MkXX7RqdDy1PrtJSkuWe","dishPortion":"bTGi80OA6_vcTcUZsWYO","placeHolderShimmer":"pxs7yzPiAgXpKAPMS4PQ"};